import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const FavoriteFilled16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M7.40837 1.16674C7.5867 1.0577 7.79167 1 8.0007 1C8.20972 1 8.41469 1.0577 8.59303 1.16674C8.77136 1.27578 8.91613 1.43193 9.01139 1.61799L9.01317 1.62145L10.7273 5.01753L13.975 5.33927C14.1874 5.35816 14.3901 5.43689 14.5597 5.56638C14.7309 5.69719 14.8611 5.87434 14.9348 6.07684C15.0085 6.27934 15.0226 6.49871 14.9755 6.70899C14.9283 6.91927 14.822 7.11164 14.6689 7.26332L11.9695 9.93883L12.9711 13.5773C13.0271 13.7882 13.0209 14.0107 12.9535 14.2181C12.886 14.4256 12.76 14.6091 12.5907 14.7466C12.4214 14.8841 12.216 14.9698 11.9991 14.9934C11.7831 15.0168 11.5649 14.9776 11.3705 14.8805L11.3683 14.8793L8.00072 13.2118L4.63815 14.8771L4.63606 14.8781C4.4417 14.9754 4.22345 15.0146 4.00736 14.9911C3.7905 14.9676 3.58507 14.8819 3.41576 14.7444C3.24645 14.6068 3.12048 14.4233 3.053 14.2159C2.98552 14.0084 2.9794 13.7859 3.03539 13.5751L3.03696 13.5692L4.03695 9.93675L1.33548 7.26125C1.18242 7.10956 1.07587 6.91702 1.02875 6.70674C0.981632 6.49647 0.995754 6.27709 1.06944 6.07459C1.14313 5.87209 1.27331 5.69495 1.44455 5.56413C1.61406 5.43464 1.81679 5.35591 2.02917 5.33702L5.27672 5.01529L6.98999 1.61798C7.08525 1.43192 7.23004 1.27578 7.40837 1.16674Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
